import React, { useEffect, useRef } from 'react';
import { Loader2 } from 'lucide-react';
import { cabinetPath, cabinetUrl } from '../lib/domains';
import { beginMerchantImpersonation, clearMerchantImpersonation } from '../lib/merchantSession';

export const MerchantImpersonatePage: React.FC = () => {
    const handled = useRef(false);
    useEffect(() => {
        if (handled.current) return;
        handled.current = true;
        const token = new URLSearchParams(window.location.hash.slice(1)).get('token');
        window.history.replaceState(null, '', window.location.pathname);
        if (!token) {
            clearMerchantImpersonation();
            window.location.replace(cabinetUrl('admin', '/dashboard'));
            return;
        }
        beginMerchantImpersonation(token);
        window.location.replace(cabinetPath('merchant', '/dashboard'));
    }, []);

    return <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin mr-3" />
        Открываем дашборд мерчанта…
    </div>;
};
